import { SettingsMenu } from "web/components"

export default function SelectedItemActions({ actions, data, selected }) {
  return (
    <div className="flex items-center rounded-lg bg-primary-10 px-1.5 py-1 text-sm text-primary-4">
      <span className="ml-2 mr-1 font-medium tabular-nums">
        {selected.length} selected
      </span>
      <SettingsMenu
        id="selected-item-actions-dropdown"
        menuItems={actions.map(({ label, action, icon }) => ({
          label,
          icon: icon,
          onClick: () => action({ all: data, selected }),
        }))}
      />
    </div>
  )
}
